import script from "./ScheduleMeetingReminderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScheduleMeetingReminderModal.vue?vue&type=script&setup=true&lang=ts"

import "./ScheduleMeetingReminderModal.vue?vue&type=style&index=0&id=2319604f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2319604f"]])

export default __exports__